import { QueryKey } from '@tanstack/react-query'

export const queryKeys = {
  asset: (assetId: string): QueryKey => ['textEditor', 'asset', assetId],
  collaborationToken: (documentId: string): QueryKey => [
    'textEditor',
    'collaborationToken',
    documentId,
  ],
  document: (id: string): QueryKey => ['textEditor', 'document', id],
}
